export type GetComponentConversionRulesResponse = {
  envCopyCpntAttrCnvRule: EnvCopyComponentAttrCnvRule[];
};

export type EnvCopyComponentAttrCnvRule = {
  cpntAttrCnvRuleId: string;

  envrnmntIdFrom: string;
  envrnmntIdTo: string;

  cpntAttrNum: string;
  cpntAttrName: string;

  cpntId: string;

  cpntAttrCnvRuleTypeCd: string;

  cpntAttrCnvRuleTypeName: string;

  rplcmntFromAttrStngVal: string;

  rplcmntToAttrStngVal: string;

  attrStngVal: string;

  updateDateTime: string;
};
